import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import {ActionsQuery} from "../../repository/actions-query";
import {BuildingSummary} from "../../../../common/model/building-summary";
import {AppConfig} from "../../../../../config/app.config";
import {Localization} from "../../../../common/enums/localization";
import {SortDirection} from "../../../../common/enums/enums";
import {AssignBoardFilters} from "../assign-board-filters/assign-board-filters";
import {AssignBoardFiltersComponent} from "../assign-board-filters/assign-board-filters/assign-board-filters.component";
import {InterventionTeamService} from "../../../../buildings/service/inspection-team.service";
import {MatMenuTrigger} from '@angular/material/menu';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {InterventionTeamDetailDto} from '../../../intervention-teams/teams/intervention-team-detail.dto';

@Component({
  selector: 'app-assign-board-controls',
  templateUrl: './assign-board-controls.component.html',
  styleUrls: ['./assign-board-controls.component.scss'],
})
export class AssignBoardControlsComponent implements OnInit {

  @Input() filters: AssignBoardFilters;
  @Output() filtersChange = new EventEmitter<AssignBoardFilters>();

  @Input() teams: InterventionTeamDetailDto[];
  @Input() enableMenu = false;
  @Input() count: number;
  @Output() changed = new EventEmitter<ActionsQuery>();
  @Output() delete = new EventEmitter<void>();
  @Output() assign = new EventEmitter<InterventionTeamDetailDto>();
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;

  public sortDirection = SortDirection.DESC;

  public readonly Localization = Localization;
  public SortDirection = SortDirection;

  constructor(
      private readonly appConfig: AppConfig,
      private readonly dialogs: MatDialog,
  ) {
  }

  ngOnInit() {
    this.filters = this.filters || new AssignBoardFilters();
    this.filtersChange.emit(this.filters);
  }

//
  public openFiltersModal() {
    const filtersDialog: MatDialogRef<AssignBoardFiltersComponent, AssignBoardFilters> =
        this.dialogs.open(
            AssignBoardFiltersComponent, {panelClass: 'full-bleed', data: this.filters}
        );
    filtersDialog.afterClosed().subscribe((filters) => this.filtersChange.emit(filters));
  }

  public buildingDidChange(building: BuildingSummary | undefined) {
    this.filters.buildingGuid = building?.guid;
    this.filtersChange.emit(this.filters);
  }

  public sortDescending() {
    this.filters.sortDirection = SortDirection.DESC;
    this.filtersChange.emit(this.filters);
  }

  public sortAscending() {
    this.filters.sortDirection = SortDirection.ASC;
    this.filtersChange.emit(this.filters);
  }

  toggleMenu() {
    if (this.enableMenu) {
      this.trigger.toggleMenu();
    }
  }
}

